<template>
  <div class="share-code-content-page">
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="toQueryRelevantInformationByEmployeePhone"
    >
      <div class="h-content">
        <div class="share-code-content-wrap">
          <div class="wrap-box">
            <div class="wrap-box-value">{{ info.bindPersonNum || 0 }}</div>
            <div class="wrap-box-text">绑定人数</div>
          </div>
          <div class="wrap-box">
            <div class="wrap-box-value">{{ info.transactionPersonNum || 0 }}</div>
            <div class="wrap-box-text">交易人数</div>
          </div>
          <div class="wrap-box">
            <div class="wrap-box-value">{{ info.amount || 0 }}</div>
            <div class="wrap-box-text">交易金额(元)</div>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <div class="share-code-content-page-btn-wrap">
      <div
        class="share-code-content-page-btn"
        @click="toShareCodePost"
      >
        生成我的分享码
      </div>
      <div
        v-if="$parent.$parent.showBottomNavBar"
        class="h-bottom-nav"
      />
    </div>
  </div>
</template>

<script>
import { queryRelevantInformationByEmployeePhone } from '../common/api.js';

export default {
  name: 'ShareCodeContent',
  data() {
    return {
      info: {},
      showPullRefreshLoading: false
    };
  },
  created() {
    this.toQueryRelevantInformationByEmployeePhone();
  },
  methods: {
    toShareCodePost() {
      this.$router.push({
        name: 'ChargingVoucherAgencyShareCodePost'
      });
    },
    toQueryRelevantInformationByEmployeePhone() {
      const param = {
        agencyCode: localStorage.getItem('_encryptAgencyCode') || '',
        phone: localStorage.getItem('_phone') || ''
      };
      this.showPullRefreshLoading = true;
      queryRelevantInformationByEmployeePhone(param)
        .then((res) => {
          if (res) {
            this.info = res || {};
          }
        })
        .finally(() => {
          setTimeout(() => {
            this.showPullRefreshLoading = false;
          }, 500);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.share-code-content-page {
  background: #f9f9f9;
  height: 100vh;
  box-sizing: border-box;
  padding: 28px 32px;

  .share-code-content-wrap {
    background: #ffffff;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 48px 0px;
    box-sizing: border-box;

    .wrap-box {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;
      flex-shrink: 0;

      .wrap-box-value {
        font-size: 48px;
        color: #225e99;
        text-align: center;
        font-weight: bold;
        line-height: 67px;
      }
      .wrap-box-text {
        font-size: 24px;
        color: #383838;
        letter-spacing: 0.36px;
        text-align: center;
        font-weight: 400;
        line-height: 33px;
      }
    }
  }
  .share-code-content-page-btn-wrap {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 15px 32px;
    box-sizing: border-box;
    background: #ffffff;
    box-shadow: inset 0px 1px 0px 0px rgba(230, 230, 230, 1);

    .share-code-content-page-btn {
      background: #fe6456;
      border-radius: 20px;
      font-size: 32px;
      color: #ffffff;
      text-align: center;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90px;
    }
  }
}
.h-bottom-nav {
  height: calc(98px + constant(safe-area-inset-bottom));
  height: calc(98px + env(safe-area-inset-bottom));
}
.h-content {
  height: calc(100vh - 56px);
}
</style>
